var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.75H12.25M3.75 14.25H12.25M4.75 1.75V3.6C4.75 4.5 5.2 5.34 5.95 5.84L8 7.2L10.05 5.84C10.8 5.34 11.25 4.5 11.25 3.6V1.75M4.75 14.25V12.4C4.75 11.5 5.2 10.66 5.95 10.16L8 8.8L10.05 10.16C10.8 10.66 11.25 11.5 11.25 12.4V14.25",
    stroke: "var(--stroke-0, #6172F3)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeration);
export default __webpack_public_path__ + "static/media/moderation.1740f93de6ee565651c9ea0e167b34ba.svg";
export { ForwardRef as ReactComponent };